import { render, staticRenderFns } from "./MerchantserviceModal.vue?vue&type=template&id=838e55d8&scoped=true&"
import script from "./MerchantserviceModal.vue?vue&type=script&lang=js&"
export * from "./MerchantserviceModal.vue?vue&type=script&lang=js&"
import style0 from "./MerchantserviceModal.vue?vue&type=style&index=0&id=838e55d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838e55d8",
  null
  
)

export default component.exports